import { Link } from "react-router-dom";
import { Sparkles, Camera, Store, Globe } from "lucide-react";
import { COMPANY_ADDRESS, COMPANY_NAME, LEGAL_NAME } from "@/constants/company";

const PILLARS = [
  { icon: Sparkles, title: "AI discovery", desc: "Natural-language search and styling that match shoppers to the right pieces." },
  { icon: Camera, title: "AI studio", desc: "Turn a flat lay into an editorial model shot before a listing goes live." },
  { icon: Store, title: "Multichannel selling", desc: "Sellers list their own inventory and crosslist across leading marketplaces." },
  { icon: Globe, title: "Curated catalog", desc: "A blend of independent sellers and partner brands, surfaced by relevance." },
];

export default function About() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="text-[11px] tracking-luxe uppercase text-aura-muted mb-2">About</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-5">
        An AI-powered marketplace.
      </h1>
      <p className="text-base text-aura-muted leading-relaxed max-w-2xl mb-4">
        {COMPANY_NAME} is a marketplace for every category — electronics, home, beauty, sports,
        fashion, and more. We help people discover products they will love, and help independent
        sellers list them. Natural-language search, price compare, and partner catalogs sit in
        one shop. {COMPANY_NAME} is part of {LEGAL_NAME}. The legal name of the business is {LEGAL_NAME}, {COMPANY_ADDRESS}.
      </p>
      <p className="text-base text-aura-muted leading-relaxed max-w-2xl mb-10">
        Our mission is to make merchandising, comparison, and cross-channel selling accessible
        to every seller — from a single listing to a growing shop — with tools that used to
        be reserved for large retailers.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mb-12">
        {PILLARS.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="border border-aura-border p-5 rounded-lg">
            <Icon className="w-5 h-5 text-aura-accent mb-3" />
            <div className="font-medium mb-1">{title}</div>
            <p className="text-sm text-aura-muted leading-relaxed">{desc}</p>
          </div>
        ))}
      </div>

      <h2 className="font-serif text-2xl mb-3">Partner products & affiliate links</h2>
      <p className="text-sm text-aura-muted leading-relaxed max-w-2xl mb-10">
        Alongside items from independent sellers, Shoptosa surfaces products from partner retailers
        and brands. When you buy through certain partner links, we may earn a commission at no extra
        cost to you, and checkout is completed on the retailer's own site. See our{" "}
        <Link to="/terms" className="link-underline">Terms</Link>,{" "}
        <Link to="/returns" className="link-underline">Returns &amp; refunds</Link>, and{" "}
        <Link to="/privacy" className="link-underline">Privacy Policy</Link> for details.
      </p>

      <div className="border-t border-aura-border pt-8">
        <p className="text-sm text-aura-muted">
          Want to work with us or sell on Shoptosa?{" "}
          <Link to="/contact" className="link-underline">Get in touch</Link> or{" "}
          <Link to="/auth?mode=register&role=seller" className="link-underline">become a seller</Link>.
        </p>
      </div>
    </div>
  );
}
